import React from "react";
import { Typography } from "@mui/material";
import {
  FaChrome,
  FaFirefox,
  FaSafari,
  FaEdge,
  FaOpera,
  FaQuestion,
} from "react-icons/fa";

const BrowserData = ({ analyticsData, themeBg }) => {
  const allBrowserData = analyticsData?.sessions?.byBrowser || [];
  
  // Limit to top 6 browsers
  const displayedBrowsers = allBrowserData.slice(0, 7);
  
  // Calculate number of remaining browsers
  const remainingCount = Math.max(0, allBrowserData.length - 7);

  // Function to get the appropriate icon for each browser
  const getBrowserIcon = (browserName) => {
    switch (browserName.toLowerCase()) {
      case "chrome":
      case "chromemobile":
        return <FaChrome style={{ color: "#4285F4", marginRight: "10px" }} />;
      case "firefox":
        return <FaFirefox style={{ color: "#FF7139", marginRight: "10px" }} />;
      case "safari":
      case "mobilesafari":
        return <FaSafari style={{ color: "#1C9CEA", marginRight: "10px" }} />;
      case "edge":
      case "edgemobile":
        return <FaEdge style={{ color: "#0078D7", marginRight: "10px" }} />;
      case "opera":
        return <FaOpera style={{ color: "#FF1B2D", marginRight: "10px" }} />;
      default:
        return <FaQuestion style={{ color: "#CCCCCC", marginRight: "10px" }} />;
    }
  };

  // Helper function to get color for each browser's percentage bar
  function getBrowserColor(browserName) {
    switch (browserName.toLowerCase()) {
      case "chrome":
      case "chromemobile":
        return "#4285F4";
      case "firefox":
        return "#FF7139";
      case "safari":
      case "mobilesafari":
        return "#1C9CEA";
      case "edge":
      case "edgemobile":
        return "#0078D7";
      case "opera":
        return "#FF1B2D";
      default:
        return "#CCCCCC";
    }
  }

  return (
    <div
      style={{
        backgroundColor: themeBg || "#0369A1",
        borderRadius: "12px",
        padding: "20px",
        color: "#FFFFFF",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography
        variant="h6"
        style={{ fontWeight: "bold", marginBottom: "10px" }}
      >
        Browser Data
      </Typography>
      
      {/* Column Headers */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
          borderBottom: "2px solid rgba(255, 255, 255, 0.3)",
          paddingBottom: "8px",
          fontWeight: "bold",
        }}
      >
        <Typography
          variant="body2"
          style={{
            fontSize: "14px",
            flex: 3,
          }}
        >
          Browser
        </Typography>
        <Typography
          variant="body2"
          style={{
            flex: 2,
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Sessions
        </Typography>
        <Typography
          variant="body2"
          style={{
            flex: 1,
            fontSize: "14px",
            textAlign: "right",
          }}
        >
          %
        </Typography>
      </div>
      
      {/* Browser Data Rows - Limited to top 6 */}
      {displayedBrowsers.length > 0 ? (
        displayedBrowsers.map((browser, index) => (
          <div key={index}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "5px 0",
                borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            >
              {/* Browser Icon and Name */}
              <div style={{ display: "flex", alignItems: "center", flex: 3 }}>
                {getBrowserIcon(browser.browser)}
                <Typography
                  variant="body2"
                  style={{
                    fontSize: "14px",
                    wordBreak: "break-word",
                  }}
                >
                  {browser.browser}
                </Typography>
              </div>

              {/* Sessions */}
              <Typography
                variant="body2"
                style={{
                  flex: 2,
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                {browser.sessions}
              </Typography>

              {/* Percentage */}
              <Typography
                variant="body2"
                style={{
                  flex: 1,
                  fontSize: "14px",
                  textAlign: "right",
                }}
              >
                {browser.percentage}
              </Typography>
            </div>

            {/* Percentage Bar */}
            <div style={{ 
              width: "100%", 
              height: "4px",
              backgroundColor: "rgba(255,255,255,0.1)",
              marginBottom: "8px",
              borderRadius: "2px",
            }}>
              <div style={{
                width: browser.percentage ? `${parseFloat(browser.percentage)}%` : "0%",
                height: "100%",
                backgroundColor: getBrowserColor(browser.browser),
                borderRadius: "2px",
              }} />
            </div>
          </div>
        ))
      ) : (
        <Typography variant="body2">No browser data available</Typography>
      )}
      
      {/* Note about remaining browsers */}
      {remainingCount > 0 && (
        <div style={{ 
          marginTop: "12px", 
          textAlign: "center", 
          fontSize: "12px", 
          color: "rgba(255,255,255,0.7)",
          fontStyle: "italic",
          borderTop: "1px dashed rgba(255,255,255,0.3)",
          paddingTop: "8px"
        }}>
          + {remainingCount} more browser{remainingCount !== 1 ? 's' : ''} not shown
        </div>
      )}
    </div>
  );
};

export default BrowserData;
